import { render, staticRenderFns } from "./ContentStaticProvider.vue?vue&type=template&id=960fa2b0&scoped=true&"
import script from "./ContentStaticProvider.vue?vue&type=script&lang=js&"
export * from "./ContentStaticProvider.vue?vue&type=script&lang=js&"
import style0 from "./ContentStaticProvider.vue?vue&type=style&index=0&id=960fa2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960fa2b0",
  null
  
)

export default component.exports